import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AccountManagersService } from 'src/app/accountmanagers/accountmanagers.service';
import { loadJobFulfillmentType, loadJobFulfillmentTypeSuccess, loadJobFulfillmentTypeFailure } from '../actions/job-fulfillment-type.actions';
import { OptionModel } from '../grid/filters/option.model';

@Injectable()
export class JobFulfillmentTypeEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _service: AccountManagersService
    ) { }

    selectJobFulfillmentType$ = createEffect(() =>
        this._actions$.pipe(
            ofType(loadJobFulfillmentType),
            switchMap(() => {
                return this._service.getJobFulfillmentTypes()
                .pipe(
                    map((jobFulfillmentTypes: OptionModel[]) => loadJobFulfillmentTypeSuccess({ jobFulfillmentTypes: jobFulfillmentTypes })),
                    catchError((error: unknown) => of(loadJobFulfillmentTypeFailure({ error })))
                );
            })
        )
    );
}
